import {AUTHORIZATION_RID, GAME_MATCH_ID_RESULT, GAME_RESULTS_RID, PARTNER_CONFIG_RID} from "./RequestDatas";
import Utils from "../utils/Utils";

const SOCKET_URL = "wss://eu-swarm-virtual-ws.betconstruct.com/";
const SOCKET_URL_STAGING = "wss://swarm-virtuals-staging.betconstruct.com";
let webSocket;

export default class RequestManager {
  static SOCKET_CLOSED_EVENT = "SOCKET_CLOSED_EVENT";
  static AUTHORIZATION_EVENT = "AUTHORIZATION_EVENT";
  static PARTNER_DATA_EVENT = 'PARTNER_DATA_EVENT';
  static GAME_RESULTS_EVENT = 'GAME_RESULTS_EVENT';
  static GAME_MATCH_ID_RESULTS_EVENT = 'GAME_MATCH_ID_RESULTS_EVENT';

  static instance = null;

  constructor() {
    this.setupWebSocket();
  }

  static getInstance() {
    if (RequestManager.instance === null) {
      RequestManager.instance = new RequestManager();
    }

    return RequestManager.instance;
  }

  setupWebSocket() {
    const socketURL = Utils.STAGING_MODE || Utils.DEV_MODE ? SOCKET_URL_STAGING : SOCKET_URL;
    webSocket = new WebSocket(socketURL);

    webSocket.onmessage = (event) => {
      const response = JSON.parse(event.data);
      const requestID = response.rid.toString();
      let socketEvent;

      switch (requestID) {
        case AUTHORIZATION_RID:
          socketEvent = new CustomEvent(RequestManager.AUTHORIZATION_EVENT, {detail: response,});
          break;
        case PARTNER_CONFIG_RID:
          socketEvent = new CustomEvent(RequestManager.PARTNER_DATA_EVENT, {detail: response});
          break;
        case GAME_RESULTS_RID:
          socketEvent = new CustomEvent(RequestManager.GAME_RESULTS_EVENT, {detail: response});
          break;
        case GAME_MATCH_ID_RESULT.rid:
          socketEvent = new CustomEvent(RequestManager.GAME_MATCH_ID_RESULTS_EVENT, {detail: response});
          break;
        default:
          console.log("REQUEST CANT DEFINED: ", response);
      }

      if (socketEvent) {
        webSocket.dispatchEvent(socketEvent);
      }
    };

    webSocket.onclose = () => {
      RequestManager.instance = null;
      webSocket.dispatchEvent(new CustomEvent(RequestManager.SOCKET_CLOSED_EVENT));
      webSocket.close();
    };
  }

  get webSocket() {
    return webSocket;
  }
}
